import { Button } from '@mui/material';
import useParagraphLineClamped from '../../../../hooks/useLineClamped';
import { OutlinedPlus } from '../../svgIcon/outlined';

interface IBusinessDescription {
  description: string;
  canEdit: boolean;
  onOpenEditInfoModal: () => void;
}

const BusinessDescription = ({
  description,
  ...rest
}: IBusinessDescription) => {
  return description ? (
    <HasDescription description={description} />
  ) : (
    <NonDescription {...rest} />
  );
};

const HasDescription = ({ description }: { description: string }) => {
  const {
    isClamped,
    contentRef,
    maxHeight,
    setMaxHeight,
    showSeeMore,
    setShowSeeMore,
  } = useParagraphLineClamped({
    linesAllowed: 3,
  });

  return (
    <div>
      <p
        ref={contentRef}
        className="text-slate_gray font-medium text-sm leading-[120%] break-words overflow-hidden"
        style={{ maxHeight }}
      >
        {description}
      </p>
      {isClamped && <span className="inline-block w-fit">...</span>}
      {isClamped && !showSeeMore && (
        <span
          onClick={() => {
            setShowSeeMore(true);
            setMaxHeight('none');
          }}
          className="text-primary_blue cursor-pointer"
        >
          Xem thêm
        </span>
      )}
    </div>
  );
};

const NonDescription = ({
  canEdit,
  onOpenEditInfoModal,
}: {
  canEdit: boolean;
  onOpenEditInfoModal: () => void;
}) => {
  return (
    <div className="flex items-center gap-5">
      <p className="text-slate_gray font-medium text-sm leading-[120%] break-words overflow-hidden">
        {'Chưa có mô tả'}
      </p>
      {canEdit && (
        <Button
          onClick={onOpenEditInfoModal}
          startIcon={<OutlinedPlus width={20} height={20} />}
          className="!normal-case !font-semibold !text-sm !leading-[16px] !tracking-[-0.1px] !text-Primary/Main hover:!bg-Action/Hover active:!bg-transparent"
        >
          Thêm mô tả
        </Button>
      )}
    </div>
  );
};

export default BusinessDescription;
